export class NotaCargoModel {
    BILL_CHARGE_NOTE_ID: number;
    BILL_STATUS_ID: number;
    CREATION_DATE: string;
    CREATED_BY: number;
    CHARGE_NOTE_NUMBER: string;
    TOTAL_IVA: number;
    TOTAL_TAX: number;
    SUBTOTAL_BEFORE_TAX: number;
    CUSTOMER_ID: number;
    CUSTOMER_NAME: string;
    CUSTOMER_RFC: string;
    ORGANIZATION_ID: number;
    RECEIVER_PAYMENT_FORM_ID: number;
    RECEIVER_PAYMENT_METHOD_ID: number;
    RECEIVER_CFDI_USE_ID: number;
    TAX_REGIME_ID: number;
    CANCELLED_BY: number;
    CANCELLATION_DATE: string;
    CURRENCY: string;
    IVA_FACTOR: number;
    COMMENTS: string;
    NOMBRE_EMISOR: string;
    CALLE_EMISOR: string;
    COLONIA_EMISOR: string;
    CIUDAD_EMISOR: string;
    ESTADO_EMISOR: string;
    CODIGOPOSTAL_EMISOR: string;
    TELEFONO_EMISOR: string;
    CORREO_EMISOR: string;
    CALLE_RECEPTOR: string;
    COLONIA_RECEPTOR: string;
    CIUDAD_RECEPTOR: string;
    ESTADO_RECEPTOR: string;
    CODIGOPOSTAL_RECEPTOR: string;
    CANCELLATION_STATUS: string;
    RELATION_TYPE_SAT_ID: number;
    NotaCargoDocumentos: Array<NotaCargoDocumento>;
    NotaCargoDetalle: Array<NotaCargoDetail>;
    NotaCargoIdDocumentos: Array<number>;
    loacs: string;
    TOTAL: number;
    FECHA: string;
}

export class NotaCargoDocumento {
    DOCTO_RELATED_CREDIT_NOTE_ID?: number;
    BILL_ID: number;
    UUID: string;
}

export class NotaCargoDetail {
    CHARGE_NOTE_DETAIL_ID: number;
    CHARGE_NOTE_ID: number;
    ITEM_SAT_ID: number;
    ITEM_ID: number;
    UNIT_MEASURE_ID: number;
    AMOUNT: number;
    QUANTITY: number;
    DESCRIPTION: string;
    IVA_FACTOR: number;
    IVA_AMOUNT: number;
    index: number;
    isChecked: boolean;
    AMOUNT_ORIGINAL: number;
    price: number;
    checkedIva: boolean;
    totalFaltante: number = undefined;
    total: number;
    unidad: string;
    NAME_SAT: string;
    NAME: string;
}



// WEBPACK FOOTER //
// ./src/app/models/nota-cargo.ts